<template>
  <div class="pickup-filters-actions">
    <ui-input
      :value="value.query"
      clearable
      placeholder="Введите адрес или метро"
      class="pickup-filters-actions__query"
      @input="onInputQuery"
    >
      <template #prepend>
        <f-sprite-icon :icon-link="$options.icons.IconSearch.id" />
      </template>
    </ui-input>

    <ui-button
      secondary
      text="Фильтры"
      :count="countActiveFilters"
      :icon="$options.icons.IconFilter.id"
      class="pickup-filters-actions__btn"
      @click="$emit('click')"
    />
  </div>
</template>

<script>
import { debounce } from 'throttle-debounce';
import { defaultFilters } from '@/components/checkout/delivery-selector/pickup-filters/constants';
import { getActiveFiltersCount } from '@/components/checkout/delivery-selector/pickup-filters/utils';

import IconFilter from '@icons/filter.svg';
import IconSearch from '@icons/search.svg';

export default {
  name: 'pickup-filters-actions',

  icons: {
    IconFilter,
    IconSearch,
  },

  props: {
    value: {
      type: Object,
      default: () => ({ ...defaultFilters }),
    },
  },

  computed: {
    countActiveFilters() {
      return getActiveFiltersCount(this.value);
    },
  },

  methods: {
    onInputQuery: debounce(300, false, function (query) {
      this.$emit('input', { ...this.value, query });
    }),
  },
};
</script>

<style lang="scss">
.pickup-filters-actions {
  &__btn,
  &__query {
    height: 40px;
  }

  &__query {
    margin-bottom: 12px;

    &.ui-input {
      min-height: 40px;
    }

    .ui-input-prepend {
      margin-right: 8px;
    }

    .sprite-icon {
      width: 20px;
      height: 20px;
      color: $gray_lu;
    }

    .close > svg {
      width: 16px;
      height: 16px;
      cursor: pointer;
    }
  }

  &__btn {
    width: 100%;
    min-height: 40px;
    background-color: #fff;

    .ui-button-content {
      align-items: center;
    }

    .sprite-icon {
      flex-shrink: 0;
      margin-right: 8px;
      width: 20px;
      height: 20px;
    }
  }
}

@include breakpoint("tablet") {
  .pickup-filters-actions {
    display: flex;
    width: 100%;

    &__query {
      margin: 0 8px 0 0;
    }

    &__btn,
    &__query {
      width: 50%;
    }
  }
}

@include breakpoint("desktop") {
  .pickup-filters-actions {
    flex-direction: row-reverse;

    &__query {
      width: 100%;
      margin: 0 0 0 8px;
    }

    &__btn {
      flex-shrink: 0;
      box-sizing: border-box;
      width: 113px;
      padding: 8px 13px;
    }
  }
}
</style>
